import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { PrimeReactProvider } from 'primereact/api/api.esm.js';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';

// PrimeReact styles - correct order
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// Components 
import FabricList from './components/FabricList.jsx';
import FabricDetail from './components/FabricDetail.jsx';
import Login from './components/Login.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<FabricList />} />
            <Route path="/tela/:code" element={<FabricDetail />} />
          </Route>
          
          {/* Fallback route - redirect unknown paths to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </PrimeReactProvider>
  </React.StrictMode>
);
